export default "../media/work_clientLogos.78fa5480ea31890b05da0a928ad0e244.gif";